<template lang="pug">
  .contact_item(
    @click="onClick",
    :class="[contact.type, { active, 'special': contact.special, disabled }]")
    .contact_preview(v-if="contact.avatar", :style="{ 'background-image': 'url(' + contact.avatar + ')' }")
    .contact_preview(v-else)
      AvatarPlaceholder.md(:fullName="contact.name", :classname="getAvatarClass(contact.name)")
    .contact_info
      .contact_info__name
        .name_wrap
          span {{ contact.name }}
      .contact_info__shortmsg {{ contact.message }}
      .contact_date {{ date }}
</template>

<script>
import AvatarPlaceholder from '@/components/AvatarPlaceholder';
import SvgMsgLogo from '@/components/svg/SvgMsgLogo';
import SvgMsgGroup from '@/components/svg/SvgMsgGroup';
import SvgMsgDollar from '@/components/svg/SvgMsgDollar';
import { getAvatarClass } from '@/utils';
import socket from '@/socket';
import { SET_ACTIVE_CHAT, UPDATE_RECENT_CHATS } from '@/store/modules/chats/types';

export default {
  components: {
    SvgMsgLogo,
    SvgMsgGroup,
    SvgMsgDollar,
    AvatarPlaceholder
  },
  methods: {
    onClick() {
      // create or set active private chats for testing purposes
      socket.emit('create-private-chat', { user_id: this.contact.id }, this.onPrivateChatCreated);
    },
    onPrivateChatCreated(data) {
      this.$store.commit(`chats/${UPDATE_RECENT_CHATS}`, data);
      this.$store.commit(`chats/${SET_ACTIVE_CHAT}`, data);
    }
  },
  props: {
    contact: { type: Object, required: true },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      getAvatarClass
    };
  },
  computed: {
    unreadMessages() {
      return this.$store.state.chats.unreadMessagesCount[this.contact.id] || 0;
    },
    activeChat() {
      return this.$store.state.chats.activeChat;
    },
    active() {
      if (!this.activeChat) return false;

      return this.activeChat.id === this.contact.id;
    },
    date() {
      const now = new Date();
      const date = new Date(this.contact.date);
      const minutes = date.getMinutes();
      const hours = date.getHours();
      const day = date.getDate();

      const diff = now - date;
      const diffHours = Math.floor(diff / 1000 / 60 / 60);

      if (diffHours < 1) return this.$t('timing.minutesAgo', { number: Math.floor(diff / 1000 / 60) });

      if (diffHours >= 1 && diffHours < 24) {
        return day === now.getDate() ? `${hours}:${minutes}` : this.$t('timing.yesterday');
      }

      return this.$options.filters.contactDate(this.contact.date, this.$i18n.locale);
    }
  }
};
</script>

<style lang="scss" scoped>
  @import '../assets/scss/variables';

  .contact {
    &_item {
      width: 100%;
      max-width: 360px;
      padding: 16px 23px 14px;
      display: flex;
      position: relative;
      cursor: pointer;
      align-items: center;
      border-radius: 6px;

      @media screen and (max-width: 1024px) { max-width: 100%; }

      @media screen and (max-width: 445px) {
        padding-left: 10px;
        padding-right: 10px;
      }

      &.ticked .contact_info__name svg { fill: $orange-3; }

      &.disabled {
        pointer-events: none;
        opacity: .3;
        cursor: default;
      }
    }

    &_preview {
      width: 50px;
      height: 50px;
      background: $light-theme-line center;
      background-size: cover;
      border-radius: 50%;
      min-width: 50px;
    }

    &_info {
      margin-left: 14px;
      max-width: 250px;
      width: 100%;
      position: relative;

      @media screen and (max-width: 1024px) { max-width: 100%; }

      &__name {
        display: flex;
        align-items: center;
        line-height: normal;
        font-size: 16px;
        color: $sub-black;
        font-weight: 600;
        width: 100%;
        position: relative;
        justify-content: space-between;

        .name_wrap {
          display: flex;
          align-items: center;
        }

        .name_cancel {
          color: $error-color;
          font-weight: 600;
          font-size: 16px;
        }

        span {
          text-align: left;
          display: block;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          max-width: 170px;
        }

        svg {
          width: 18px;
          height: 18px;
          fill: currentColor;
          margin-right: 9px;
        }
      }

      &__shortmsg {
        line-height: normal;
        font-size: 12px;
        text-align: left;
        margin-top: 8px;
        color: $light-theme-text;
        font-weight: 600;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        width: 85%;
      }
    }

    &_date {
      font-size: 12px;
      color: $light-theme-text;
      font-weight: 600;
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  .special .contact_info__name { color: $orange-3; }

  .contact_count {
    line-height: normal;
    font-size: 11px;
    text-align: center;
    color: $white;
    background: $error-color;
    font-weight: 600;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    position: absolute;
    top: 0;
    right: -2px;
  }

  .active { background: $light-theme-line; }

  svg.logo { fill: $orange-3; }
</style>
